module.exports = __webpack_public_path__ + "assets/img/config-table-a8fc221f.png";